import { writable } from "svelte/store";

export const structureTreeOpen = writable(false);
